module.exports = __webpack_public_path__ + "static/img/ruanjianzhuzuoquandengji.5f2cfbe3.jpg";